import * as THREE from "../../libs/three.js/build/three.module.js";
import {MOUSE} from "../defines.js";
import {EventDispatcher} from "../EventDispatcher.js";

 
export class PanoramaControls extends EventDispatcher{
	
	constructor(viewer){
		super();
		
		this.viewer = viewer;
		this.renderer = viewer.renderer;

		this.scene = null;
		this.sceneControls = new THREE.Scene();

		this.rotationSpeed = 5;

		this.fadeFactor = 20;
		this.yawDelta = 0;
		this.pitchDelta = 0;
		this.panDelta = new THREE.Vector2(0, 0);
		this.radiusDelta = 0;

		this.doubleClockZoomEnabled = true;

		this.tweens = [];

		let drag = (e) => {
			if (e.drag.object !== null) {
				return;
			}

			if (e.drag.startHandled === undefined) {
				e.drag.startHandled = true;

				this.dispatchEvent({type: 'start'});
			}

			let ndrag = {
				x: e.drag.lastDrag.x / this.renderer.domElement.clientWidth,
				y: e.drag.lastDrag.y / this.renderer.domElement.clientHeight
			};

			if (e.drag.mouse === MOUSE.LEFT) {
				this.yawDelta -= (ndrag.x * (this.viewer.scene.getActiveCamera().fov * this.viewer.scene.getActiveCamera().aspect) * Math.PI) / 180;
				this.pitchDelta -= (ndrag.y * this.viewer.scene.getActiveCamera().fov * Math.PI) / 180;
				this.dispatchEvent({type: 'change'});
			}
		};

		let drop = e => {
			this.dispatchEvent({type: 'end'});
		};

		let scroll = (e) => {
			let fov = this.viewer.scene.getActiveCamera().fov - (5 * e.delta);

			if(fov < 10) fov = 10;
			if(fov > 90) fov = 90;

			this.viewer.setFOV(fov);
			this.dispatchEvent({type: 'change'});
		};

		let onTouchMove = (e) => {
			if (e.touches.length == 2){
				let currDX = e.touches[0].pageX - e.touches[1].pageX;
				let currDY = e.touches[0].pageY - e.touches[1].pageY;
				let currDist = Math.sqrt(currDX * currDX + currDY * currDY);
				
				if(this.prevDist) {
					let delta = currDist - this.prevDist;
					
					let fov = this.viewer.scene.getActiveCamera().fov - (delta / 5);

					if(fov < 10) fov = 10;
					if(fov > 90) fov = 90;

					this.viewer.setFOV(fov);
					this.dispatchEvent({type: 'change'});
				}

				this.prevDist = currDist;
			}
		};

		let onTouchEnd = (e) => {
			this.prevDist = null;
		}

		this.addEventListener('drag', drag);
		this.addEventListener('drop', drop);
		this.addEventListener('mousewheel', scroll);
		this.addEventListener('touchmove', onTouchMove);
		this.addEventListener('touchend', onTouchEnd);
	}

	setScene (scene) {
		this.scene = scene;
	}

	stop(){
		this.yawDelta = 0;
		this.pitchDelta = 0;
		this.radiusDelta = 0;
		this.panDelta.set(0, 0);
	}

	update (delta) {
		let view = this.scene.view;

		{ // apply rotation
			let progression = Math.min(1, this.fadeFactor * delta);

			let yaw = view.yaw;
			let pitch = view.pitch;

			yaw -= progression * this.yawDelta;
			pitch -= progression * this.pitchDelta;

			view.yaw = yaw;
			view.pitch = pitch;
		}

		{ // apply pan
			let progression = Math.min(1, this.fadeFactor * delta);
			let panDistance = progression * view.radius * 3;

			let px = -this.panDelta.x * panDistance;
			let py = this.panDelta.y * panDistance;

			view.pan(px, py);
		}

		{ // apply zoom
			let progression = Math.min(1, this.fadeFactor * delta);

			// let radius = view.radius + progression * this.radiusDelta * view.radius * 0.1;
			let radius = view.radius + progression * this.radiusDelta;

			let V = view.direction.multiplyScalar(-radius);
			let position = new THREE.Vector3().addVectors(view.getPivot(), V);
			view.radius = radius;

			view.position.copy(position);
		}

		{
			let speed = view.radius;
			this.viewer.setMoveSpeed(speed);
		}

		{ // decelerate over time
			let progression = Math.min(1, this.fadeFactor * delta);
			let attenuation = Math.max(0, 1 - this.fadeFactor * delta);

			this.yawDelta *= attenuation;
			this.pitchDelta *= attenuation;
			this.panDelta.multiplyScalar(attenuation);
			// this.radiusDelta *= attenuation;
			this.radiusDelta -= progression * this.radiusDelta;
		}
	}
};
